module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjYjliOWI5IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnNlYXJjaDwvdGl0bGU+PHBhdGggZD0iTTEwLjUsMTlBOC41LDguNSwwLDEsMSwxOSwxMC41LDguNTEsOC41MSwwLDAsMSwxMC41LDE5Wm0wLTE2QTcuNSw3LjUsMCwxLDAsMTgsMTAuNSw3LjUsNy41LDAsMCwwLDEwLjUsM1oiLz48cGF0aCBkPSJNMjEuNSwyMmEuNDcuNDcsMCwwLDEtLjM1LS4xNWwtNS01YS40OS40OSwwLDAsMSwuNy0uN2w1LDVhLjQ4LjQ4LDAsMCwxLDAsLjdBLjQ3LjQ3LDAsMCwxLDIxLjUsMjJaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/search-grey.svg
// module id = 239
// module chunks = 1